import React from "react";
import PropTypes from "prop-types";
import Tooltip from "../../../../common/tooltip/main";

class Attachment extends React.Component {
  postEmbedMessage = (options) => {
    const { attachment } = this.props;
    /* eslint-disable no-undef */
    // printuiFrameId defined in Rails controller/view
    const attachmentEmbedInfo = {
      key: attachment.id,
      name: attachment.attributes.filename,
      type: "embed",
      url: attachment.attributes.url,
      displayUrl: (attachment.attributes.view_thumbnail_retina
        || attachment.attributes.thumbnail_url),
      text: false,
      crop: (options['crop']),
      printuiFrameId
    };
    window.parent.postMessage(attachmentEmbedInfo, '*');
    /* eslint-enable no-undef */
  }

  downloadLink() {
    const { attachmentKey } = this.props;
    return `/${BF.fx.organization().slug}/attachments/${attachmentKey}?dl=true&resource_key=${BF.fx.organization().key}&resource_type=Organization`;
  }

  renderSize() {
    const { height, size, width } = this.props.attachment.attributes;
    if (size) {
      if (width && height) {
        return <span> {size} KB &middot; </span>;
      }
      return <span> {size} KB</span>;
    }
    return null;
  }

  renderDimensions() {
    const { height, width } = this.props.attachment.attributes;
    if (width && height) {
      return <span>{width} x {height}</span>;
    }
    return null;
  }

  renderAction() {
    const { extension } = this.props.attachment.attributes;
    if (BFG.embedView) {
      return (
        <div style={{ padding: '8px 20px 10px' }}>
          <button
            onClick={() => this.postEmbedMessage({ crop: false })}
            className="button secondary sm"
            style={{ display: 'inline', marginBottom: '5px' }}
            type="button"
          >
            Select
          </button>
          <button
            onClick={() => this.postEmbedMessage({ crop: true })}
            className="button secondary sm"
            style={{ padding: '8px 20px 10px', display: 'inline' }}
            type="button"
          >
            Crop
          </button>
        </div>
      );
    }
    if (extension) {
      return (
        <a
          href={this.downloadLink()}
          download
          target="_blank"
          rel="noopener noreferrer"
          className="pull-right j-download-attachment-link s-attachment-options"
        >
          <button className="button secondary sm" type="button">
            <div className="attachment-icon">
              <span className="bff-download-asset" aria-label="download" />
            </div>
          </button>
        </a>
      );
    }
    return null;
  }

  render() {
    const { attachment, isActive } = this.props;
    const { id, thumbnail_url, filename, mimetype, url } = attachment.attributes;
    return (
      <li
        className={`m-download-attachment s-download-computer dropdown ${isActive ? 'active' : ''}`}
        key={id}
        onClick={() => this.props.updateActiveImage(attachment)}
      >
        <div className="s-asset-card-details">
          <div className="flex-two-thirds">
            <div className="m-show-thumbnail-img flex-one-third">
              <img className="m-asset-img-thumb" src={thumbnail_url} />
            </div>
            <div className="s-image-details flex-two-thirds">
              <Tooltip
                tooltipId={`attachment-${filename}`}
                tooltipContent={filename}
              >
                <div className="s-image-name" title={filename}>
                  {filename}
                </div>
              </Tooltip>
              <div className="s-file-download-meta modal-label">
                {this.renderSize()}
                {this.renderDimensions()}
              </div>
            </div>
          </div>
          <div>
            <div className="s-download-edit-attachments">
              {(mimetype && mimetype.indexOf("video") > -1)
                && (url === null) ? (
                  <Tooltip
                    tooltipId="attachment-video"
                    tooltipContent="Preparing Media Preview"
                  >
                    <div className="dropdown-link">
                      <i className="fa-spinner fa-spin lighter-gray-text mid-gray-text-on-hover" />
                    </div>
                  </Tooltip>
                ) : (
                  ""
                )}
              {this.renderAction()}
            </div>
          </div>
        </div>
      </li>
    );
  }
}

Attachment.propTypes = {
  attachmentKey: PropTypes.string.isRequired,
  attachment: PropTypes.shape({
    attributes: PropTypes.shape({
      id: PropTypes.string,
      thumbnail_url: PropTypes.string,
      filename: PropTypes.string,
      mimetype: PropTypes.string,
      url: PropTypes.string,
      height: PropTypes.number,
      width: PropTypes.number,
      size: PropTypes.number,
      extension: PropTypes.string
    })
  }).isRequired,
  isActive: PropTypes.bool.isRequired,
  updateActiveImage: PropTypes.func.isRequired
};

export default Attachment;
